import React from 'react';
import './App.css';

function App() {
  return (
    <div className="App">
      <div className="coming-soon-container">
        <h1 className="coming-soon-title">Lawmark Law Searcher</h1>
        <p className="coming-soon-subtitle">Coming Soon</p>
        <p className="coming-soon-text">Something great is in the works. We'll be live soon!</p>
        <p className="text-right">Tailwind Test</p>
      
      </div>
    </div>
  );
}

export default App;
